export class ShortLinkAlreadyExists extends Error {
  public constructor() {
    super()

    this.message = 'shortlinks.errors.alreadyExists'
  }
}
